import { cn } from "@/lib/utils";

type WithTitleProps = ReactChildren & {
  title: string;
  className?: string;
};

const WithTitle: React.FC<WithTitleProps> = ({
  children,
  title,
  className,
}) => {
  return (
    <div
      className={cn(
        "border min-w-96 max-w-max rounded-md px-8 py-4 space-y-2",
        className,
      )}
    >
      <h2 className='text-lg '>{title}</h2>
      {children}
    </div>
  );
};

export { WithTitle };
